import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { importAssets } from "../../redux/actions/asset.actions";
import ListErrors from "../../components/ListErrors";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import {
  loadAssetAddPage,
  unloadAssetAddPage
} from "../../redux/actions/asset.actions";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

function AssetImport() {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const asset = useSelector(state => state.asset);

  useEffect(() => {
    dispatch(loadAssetAddPage());
    return () => dispatch(unloadAssetAddPage());
  }, [dispatch]);

  const handleSubmit = (site, file_source) =>
    dispatch(importAssets(site, file_source));
  if (!asset.sites) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"assets"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"assets"} />
          <div id="content">
            <Header />
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <Link className="header-button" to={`/assets`}>
                  {t("common.back")}
                </Link>
                <h2>{t("asset.import_title")}</h2>
              </div>
              <Formik
                initialValues={{ site: "" }}
                onSubmit={(payload, { setSubmitting }) => {
                  handleSubmit(payload.site, file);
                  setSubmitting(false);
                }}
              >
                {({ touched, errors, isSubmitting }) => (
                  <Form>
                    <div className={`form-item`}>
                      <label htmlFor="file">{t("asset.label_csv_file")}</label>
                      <Field
                        name="file"
                        type="file"
                        onChange={e => setFile(e.target.files[0])}
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("common.site")}</label>
                      <Field as="select" name="site">
                        <option value={""}>
                          {t("common.option_select_site")}
                        </option>
                        {asset.sites.map(item => {
                          return <option value={item.key}>{item.name}</option>;
                        })}
                      </Field>
                    </div>
                    <ListErrors errors={asset.errors} />
                    <div className="form-item">
                      <button type="submit" disabled={isSubmitting}>
                        {isSubmitting
                          ? t("system.submitting_feeback")
                          : t("asset.upload_button")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}
export default AssetImport;
